import { Fragment } from 'react'
import Vimeo from '@u-wave/react-vimeo'
import ReactPlayer from 'react-player'

export const MediaPlayer = ({
  videoUrl,
  autoPlay,
  onEnded,
  posterUrl = '',
  className = 'absolute top-0 left-0 videoplayer',
}) => {
  const isVimeo = () => videoUrl?.startsWith('https://player.vimeo')
  return (
    <Fragment key={videoUrl}>
      {isVimeo() ? (
        <Vimeo
          id="video-vimeo-player-autoplay"
          key={videoUrl}
          controls
          playsInline
          autoplay={autoPlay}
          video={videoUrl ? videoUrl : ''}
          className={className}
          onEnd={onEnded}
        />
      ) : (
        <ReactPlayer
          id="video-react-player"
          key={videoUrl}
          className={className}
          url={videoUrl ? videoUrl : ''}
          playing={autoPlay}
          controls
          onEnded={onEnded}
          playsinline={true}
          config={{
            vimeo: { playerOptions: { controls: true } },
            file: {
              attributes: {
                poster: posterUrl,
              },
            },
          }}
        />
      )}
    </Fragment>
  )
}
